import { render, staticRenderFns } from "./ParametersConfig.vue?vue&type=template&id=53ffd8b3&"
import script from "./ParametersConfig.vue?vue&type=script&lang=js&"
export * from "./ParametersConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports